
if( $('#pagina-questoes').length ) {

    var vmQuestoes = new Vue({
        el: '#pagina-questoes',
        data: {

            Filtros             : null, /* Classe Filtros, instanciada em created() */
            Paginacao           : null, /* Classe Paginacao, instanciada em created() */
            questoes            : [],
            totalQuestoes       : -1,
            questoesPorPag      : 10,
            paginaAtual         : 1,
            inputPagina         : 1,
            ultimaPagina        : 1,
            consultandoQuestao  : false,
            questoesDasProvas   : [], /* Se estiver filtrando por Ids de provas, guardo aqui */
            tempo               : 0,
            totalFiltrosAtivos  : 0,
            tamanhofonte        : 1.0,
            metaDescricao       : 'geral',
            qId                 : -1,
            lightboxCompartilhar: -1,
            suspendeWatchs      : false,
            logado              : false,
            reportarProblema         : {
                titulo      : 'Relatar Problema em Questão',
                opcoes      : [
                    {   valor: 'desatualizada',     texto: 'Questão Desatualizada'  },
                    {   valor: 'duplicada',         texto: 'Questão Duplicada'      },
                    {   valor: 'digitacao',         texto: 'Erro de Digitação'      },
                    {   valor: 'gabarito',          texto: 'Gabarito Incorreto'     },
                    {   valor: 'outro',             texto: 'Outro'     }
                ]
            },

            adsense : {
                1: '9849620040',
                4: '4680730442',
                7: '6157463640'
            },

            filtros : {
                grupos: {
                    nome: "grupos",
                    ativo: true,
                    selecionados: ["enem"],
                    opcoes: [
                        /*{valor: "concurso", texto: "Concursos"},*/
                        {valor: "enem", texto: "ENEM"}
                        /*{valor: "oab", texto: "OAB"},
                        {valor: "vestibular", texto: "Vestibulares"}*/
                    ]
                },
                palavras: {
                    nome: "palavras",
                    ativo: false,
                    selecionados: [],
                    opcoes: []
                },
                niveis: {
                    nome: "niveis",
                    ativo: false,
                    selecionados: [],
                    opcoes: [
                        {valor: "fundamental", texto: "Fundamental"},
                        {valor: "medio", texto: "Médio"},
                        {valor: "tecnico", texto: "Técnico"},
                        {valor: "superior", texto: "Superior"}
                    ]
                },
                orgaos: {
                    nome: "orgaos",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                cargos: {
                    nome: "cargos",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                bancas: {
                    nome: "bancas",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                areasformacao: {
                    nome: "areasformacao",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                areasconhecimento: {
                    nome: "areasconhecimento",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                disciplinas: {
                    nome: "disciplinas",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                assuntos: {
                    nome: "assuntos",
                    ativo: false,
                    carregando: false,
                    faltadependencia: false,
                    selecionados: [],
                    opcoes: []
                },
                tipos: {
                    nome: "tipos",
                    ativo: false,
                    selecionados: [],
                    opcoes: [
                        {valor: "objetiva", texto: "Múltipla Escolha"},
                        {valor: "ce", texto: "Certo/Errado"},
                        {valor: "discursiva", texto: "Discursiva"},
                        {valor: "redacao", texto: "Redação"}
                    ]
                },
                desde: {
                    nome: "desde",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                },
                ate: {
                    nome: "ate",
                    ativo: false,
                    carregando: false,
                    selecionados: [],
                    opcoes: []
                }
            },
            maisopcoes: {
                nome: "maisopcoes",
                ativo: false,
                opcoes: {
                    resolvi: {dual: "naoresolvi", label: "Apenas Questões Que Resolvi", valor: false},
                    naoresolvi: {dual: "resolvi", label: "Apenas Questões Que Não Resolvi", valor: false},
                    acertei: {dual: "errei", label: "Apenas Questões Que Acertei", valor: false},
                    errei: {dual: "acertei", label: "Apenas Questões Que Errei", valor: false},
                    comresolucao: {dual: "semresolucao", label: "Apenas Questões Com Resolução", valor: false},
                    semresolucao: {dual: "comresolucao", label: "Apenas Questões Sem Resolução", valor: false},
                    anuladas: {dual: "", label: "Excluir Questões Anuladas", valor: false},
                    desatualizadas: {dual: "", label: "Excluir Questões Desatualizadas", valor: false}
                }
            }
        },
        methods: {
            adicionarNaColecao: function ( questao_id ) {

                if( ! this.logado  ){
                    return nav.open('register');
                }

                fechaTooltips();
                vmColecoes.abrirModal( questao_id, 'questao' );
            },
            compartilharQuestao: function ( questao_id ) {
                this.lightboxCompartilhar = lity();
                this.lightboxCompartilhar('#compartilhar-questao');

                var input = $('#input-compartilhar-questao');
                input.val('http://www.planetaensino.com/questoes#q=[' + questao_id + ']');
                input.on('click', function () {
                    $(this).select();
                })
            },
            relatarProblema: function ( questao_id ){

                if( ! this.logado  ){
                    return nav.open('register');
                }

                fechaTooltips();

                vmRelatarProblema.problemas = this.reportarProblema;
                vmRelatarProblema.urlAjax = '/questoes/relatar-problema';
                vmRelatarProblema.abrirModal( questao_id );
            },
            offset: function () {
                return (this.paginaAtual - 1) * this.questoesPorPag;
            },
            tamanhoFonte: function (acao) {

                /* 'tamanhofonte' vem de COOKIES (se ativo), senão inicia em 1 mesmo */
                var fonte = parseFloat(this.tamanhofonte);

                if (acao == 'aumentar' && fonte < 1.8) {
                    this.tamanhofonte = (fonte + 0.1).toFixed(1);
                }
                if (acao == 'diminuir' && fonte > 0.7) {
                    this.tamanhofonte = (fonte - 0.1).toFixed(1);
                }

                Cookies.set('tamanhofonte', this.tamanhofonte);
            },
            consultaQuestao: function ( hash ) {

                var self = this;
                var ids = hash.substring(3); // "[1,2,3...]"

                // testando se o array 'ids' tá OK
                try{
                    JSON.parse(ids);
                }catch(erro){
                    return flash('Houve algum erro. Recarregue a Página.', 'erro');
                }
                
                ajaxGET('/questoes/retorna-questoes', {ids: ids}, function (retorno) {

                    self.totalQuestoes = retorno.totalQuestoes;
                    self.questoes = retorno.questoes;
                    self.tempo = retorno.tempo;
                    self.consultandoQuestao = true;

                    if (retorno.totalQuestoes > 0) {
                        self.filtros.grupos.selecionados = retorno.grupo;
                    }

                    Vue.nextTick(function () {
                        inicializaTooltips();
                    });
                });
            },
            sincronizaModelComServer: function (dadosServidor) {

                var self = this;
                this.totalQuestoes = dadosServidor.totalQuestoes;
                this.questoesPorPag = dadosServidor.questoesPorPag;
                this.ultimaPagina = dadosServidor.ultimaPagina;
                this.tempo = dadosServidor.tempo;
                this.questoes = dadosServidor.questoes;

                Vue.nextTick(function () {
                    self.suspendeWatchs = false;
                    inicializaTooltips();
                });
            },
            carregaQuestoes: function (dadosAjax) {

                var self = this;
                this.suspendeWatchs = true;

                ajaxGET(
                    '/questoes/filtrar',
                    dadosAjax,
                    function (dadosRetorno) {
                        self.consultandoQuestao = false; /* Não é consulta por IDs */
                        self.sincronizaModelComServer(dadosRetorno);
                    }
                );

            }
        },
        computed: {
            totalFiltrosAtivos: function () {

                return this.Filtros.totalFiltrosAtivos('questoes');
            },
            totalMaisOpcoesAtivas: function () {

                return this.Filtros.totalMaisOpcoesAtivas();
            }
        },
        created: function () {

            MathJax.Hub.Config({
                showProcessingMessages: false,
                messageStyle: 'none'
            });

            this.Filtros = new Filtros(this);
            this.Paginacao = new Paginacao(this);

            this.logado = ($('#dlkjfasldgh').val() == '1');
        },
        ready: function () {

            /* Inicializando o Painel de Filtros */
            $('.botao-toggle-filtros').on('click', function () {
                $('.content').toggleClass('isOpen');
            });

            this.tamanhofonte = (Cookies.get('tamanhofonte') || 1.0);

            if (location.hash) {
                this.Filtros.verificaHash();
            } else {
                this.carregaQuestoes({grupos: this.filtros.grupos.selecionados, ordem_aleatoria: 1});
            }
        }
    });


    /* SIMPLE JAVASCRIT ROUTER - BY RONI RIGONI */
    $(window).on('hashchange', function () {
        vmQuestoes.suspendeWatchs = true;
        vmQuestoes.Filtros.verificaHash();
    });


    /*
     * Monitoramos as Disciplinas selecionadas.
     * Qualquer mudança implica no recarregamento geral de Assuntos.
     * Caso contrário fica muita mão de obra pra pouca diferença.
     * */
    vmQuestoes.$watch('filtros.disciplinas.selecionados', function (newVal, oldVal) {

        /* Poderia usar a opção 'deep' no watch (que monitora os elementos do array),
         *  mas comparar os 'length' é mais simples e resolve o problema nesse caso.
         * */
        if (!this.suspendeWatchs && (newVal.length != oldVal.length)) {

            this.filtros.assuntos.ativo = false;
            this.filtros.assuntos.opcoes = [];
            this.filtros.assuntos.selecionados = [];

            // Há pelo menos uma Disciplina selecionada
            if (newVal.length) {
                this.filtros.assuntos.faltadependencia = false;
            }

        }

    });

    vmQuestoes.$watch('filtros.grupos.selecionados', function (newVal, oldVal) {

        if (!this.suspendeWatchs) {

            var msgConfirmacao = false;

            /* Verifica se algum filtro dependente de AJAX foi selecionado */
            for( var filtroNome in this.filtros ){
                if( this.filtros[filtroNome].hasOwnProperty('carregando') &&
                    this.filtros[filtroNome].selecionados.length
                ){
                    msgConfirmacao = true;
                    break;
                }
            }

            if ( msgConfirmacao ) {
                this.Filtros.confirmaMudancaGrupo(oldVal);
            } else {
                this.Filtros.limparFiltrosAjax();
            }

        }

    });

    vmQuestoes.$watch('questoesPorPag', function (newVal, oldVal) {

        if (!this.suspendeWatchs) {

            if (this.paginaAtual == 1) {
                this.Filtros.filtrar();
            } else {
                // o watch de paginaAtual vai executar o filtro.
                this.paginaAtual = 1;
            }

        }
    });

    vmQuestoes.$watch('paginaAtual', function (newVal, oldVal) {

        if (!this.suspendeWatchs) {

            this.inputPagina = this.paginaAtual;

            this.Filtros.filtrar();
        }

    });

}
